// extracted by mini-css-extract-plugin
export default {"chart":"H_c7"};